import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Invoice } from '../../../models/invoice';
import { Observable } from 'rxjs';

export class InvoiceData implements DataSource<Invoice> {

    constructor(private source$: Observable<Invoice[]>) {
    }

    connect(collectionViewer: CollectionViewer): Observable<Invoice[]> {
        return this.source$;
    }

    disconnect(collectionViewer: CollectionViewer): void {
    }
}
